// Path: src\Components\Tournament\TournamentList.jsx
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import TournamentBox from "./TournamentBox/TournamentBox";
import JoinViaInviteCode from "../JoinViaInviteCode/JoinViaInviteCode";
import BaseHome from "../Home/BaseHome";
import RulesPopup from "../Popup/RulesPopup";
import WinningBreakup from "../Popup/WinningPopup";
import JoinViaInviteCodePopup from "../Popup/JoinViaInviteCodePopup";
import TournamentRoundPopup from "../Popup/SelectRoundPopup";
import JoiningPopup from "../Popup/JoiningPopup";

import { useNavigate } from "react-router";
import { tournamentList, tournamentRules, tournamentPricePointPool, tournamentByCode, tournamentRoundsById, tournamentJoin } from "../../api/tournament.api";
import Popup from "../Popup/BasePopup";
import NewUserInGameNamePopUp from "../UserInGameName/NewUserInGameName";
import Button from "../CommonFields/Button";
import TeamRegistration from "../Common/TeamRegistration";
import { useProfileDataContext } from "../ProfileContext/ProfileContext";
import { toastSuccess, toastError } from "../../Utilities/toast";
import { routesFrontend } from "../RouterFiles/routes";
import SubscriptionPopup from '../Subscription/SubscriptionPopup';
import CustomerCareSubscriptionPopup from '../CustomerCare/CustomerCareSubscriptionPopup';
import NonPremiumMaxJoinPopup from '../Common/NonPremiumMaxJoin';
import ListLoader from '../Common/ListLoader';

export const initialFilter = {
  pagination: {
    pageNo: 1,
    recordPerPage: 5,
    sortBy: "startDate",
    sortDirection: "desc"
  },
  filter: {
    user: null
  }
};

const TournamentList = () => {
  const navigate = useNavigate();
  const { fetchAccountProfile } = useProfileDataContext();
  const { t } = useTranslation();

  const gameId = localStorage.getItem("activeGameId");
  const gameName = localStorage.getItem("activeGame");

  const [filter, setFilter] = useState(initialFilter);
  const [list, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false)

  const [isSubscriptionPopup, setSubscriptionPop] = useState(false);
  const [isRulesPopup, setIsRulesPopup] = useState(false);
  const [isPricePointPoolModel, setPricePointPool] = useState(false);
  const [isJoinViaInviteCode, setisJoinViaInviteCode] = useState(false);
  const [isTournamentRound, setisTournamentRound] = useState(false);
  const [isTournamentJoiningPopup, setisTournamentJoiningPopup] = useState(false);
  const [rules, setRules] = useState("");
  const [prizePool, setPrizePool] = useState('');
  const [item, selectedItem] = useState('');
  const [code, setCode] = useState('');
  const [joinViaCodeTournament, setJoinViaCodeTournament] = useState({});
  const [isPopupOpenTournament, setPopupOpenTournament] = useState(false);
  const [rounds, setRounds] = useState([]);
  const [firstRoundId, setFirstRoundId] = useState('');
  const [selectedMatchDate, setSelectedMatchDate] = useState('');
  const [inGameNamePopup, setinGameNamePopup] = useState(false);
  const [uniqueIgn, setUniqueIgn] = useState("");
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const [isTeamRegistrationForm, setIsTeamRegistrationForm] = useState(false);
  const [walletUsage, setWalletUsageData] = useState(null);
  const [coinStore, setCoinStore] = useState(false);
  const [isDisableJoinBtn, setIsDisableJoinBtn] = useState(false);

  useEffect(() => {
    if (currentPage <= totalPages)
      loadMore()
  }, [currentPage])

  const loadMore = async () => {
    setLoading(true)
    fetchTournaments()
    // setLoading(false)
  }

  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );

  const fetchTournaments = async () => {
    try {
      
      let data = {
        pagination: {
          pageNo: currentPage,
          recordPerPage: recordPerPage,
          sortBy: 'startDate',
          sortDirection: "asc"
        },
        filter: {
          user: JSON?.parse(localStorage?.getItem('profile'))?.user_id,
          game: gameId
        }
      }
      const res = await tournamentList(data);
      setLoading(false)
      if (res?.success && res?.data?.length > 0) {
        setUniqueIgn(res?.data?.[0]?.userInGameName?.trim())
        setList([...list, ...res?.data])
        setTotalPage(res?.totalPages);
        setTotalPages(res?.totalPages);
      }
      else {
        setList([]);
      }
    } catch (error) {
      setLoading(false)
    }
  };

  const loadMoreBtnClick = () => {
    setPage(page + 1)
    fetchTournaments(page + 1);
  };

  async function fetchRulesData(item) {
    try {
      let response = await tournamentRules(item);
      if (response?.success) {
        setRules(response?.item?.rules);
      }
      else {
        setRules('');
      }
      setIsRulesPopup(true)
    } catch (error) {
      setRules('');
    }
  }
  async function fetchPricePointPoolData(id, item) {
    selectedItem(item);
    try {
      let response = await tournamentPricePointPool(id);
      if (response?.success) {
        setPrizePool(response?.data);
      }
      else {
        setPrizePool('');
      }
      setPricePointPool(true)
    } catch (error) {
      setPrizePool('');
    }
  }

  async function handleApplyClick() {
    if (code?.trim()) {
      try {
        let payload = {
          user: JSON?.parse(localStorage?.getItem('profile'))?.user_id,
          code: code
        };
        let response = await tournamentByCode(payload);
        if (response?.success && response?.data) {
          setJoinViaCodeTournament(response?.data);
          setPopupOpenTournament(true);
          setCode('');
        } else {
          toastError(t('tournament_list.tournament_not_found'));
          setJoinViaCodeTournament({});
          setCode('');
        }
      } catch (error) {
        toastError(t('tournament_list.tournament_not_found'));
        setJoinViaCodeTournament({});
        setCode('');
      }
    }
    else {
      toastError(t('errors.error_please_enter_invite_code'));
      setJoinViaCodeTournament({});
    }
  }

  const getjoin = async (id, item) => {
    selectedItem(item);
    getRounds(id, item);
  }

  const getRounds = async (id, item) => {
    selectedItem(item);
    try {
      let response = await tournamentRoundsById(id);
      if (response?.success) {
        setRounds(response);
        setisTournamentRound(true)
      }
      else {
        setRounds([]);
      }
    } catch (error) {
      setRounds([]);
    }
  }

  const onJoinTournament = async () => {
    if (coinStore == false) {
      let data = {
        event: item?._id,
        contest: firstRoundId,
        currencyCode: item?.currency?.[0]?.inCurrency?._id,
        inGameUserName: uniqueIgn,
        uniqueIGN: uniqueIgn,
        user: JSON?.parse(localStorage.getItem("profile"))?.user_id
      };

      if (
        item?.gameTypeAry?.players &&
        parseInt(item?.gameTypeAry?.players) > 1
      ) {
        data.players = item?.gameTypeAry?.players
        data.extraPlayers = item?.gameTypeAry?.extraPlayers
        data.game_type = item?.gameTypeAry?._id
        data.game = item?.gameAry?._id
        localStorage.setItem("registerData", JSON.stringify(data))
        localStorage.setItem("registerType", "tournament")

        setisTournamentJoiningPopup(false);
        navigate("/team-registration")
      }
      else {
        try {
          const res = await tournamentJoin(data);
          if (res?.success && res?.data) {
            fetchAccountProfile()
            navigate(`/tournament/details/${item?._id}`)
          } else {
            if(res?.data?.errors[0]?.data==="events.validation.MAX_FREE_TRANSACTION"){
              setisTournamentJoiningPopup(false);
              setSubscriptionPop(true)
            }else{
              setIsDisableJoinBtn(false);
              toastError(res?.data?.errors?.[0]?.msg);
            }
          }
        } catch (error) {
          setIsDisableJoinBtn(false);
          toastError(error);
        }
      }
    }
    else {
      let redirectUrl = routesFrontend.rewards;
      navigate(redirectUrl, { state: 1 })
    }
  }

  const onJoinContestClick = (contest) => {
    setIsDisableJoinBtn(false);
    setisTournamentJoiningPopup(contest);
  }

  return (
    <>
      <BaseHome title={localStorage?.getItem('activeGame')?.toLocaleLowerCase() || "pubg"} onBackClick={() => navigate(-1)}>
        <JoinViaInviteCode setCode={setCode} code={code} handleApplyClick={handleApplyClick} />
        {list && list?.length > 0 ?
          <>
            {list?.map((item, index) => {
              return (
                <div key={index} ref={list?.length === index + 1 ? lastPostElementRef : null}>
                  <TournamentBox item={item} setIsRulesPopup={fetchRulesData} setPricePointPool={() => { selectedItem(item); setPricePointPool(true) }} getjoin={getjoin} />
                </div>
              )
            })}
          </>
          : !loading && <div className='w-100 d-flex justify-content-center no-record-found-center'><span className="text-center">{t('common.no_data_found')}</span></div>
        }
        
        {loading && <div className='w-100 d-flex justify-content-center no-record-found-center'> <ListLoader /></div>}
        {isPopupOpenTournament && (
          <Popup isOpen={isPopupOpenTournament} title={localStorage?.getItem('activeGame')?.toLocaleLowerCase() || "pubg"} onClose={() => setPopupOpenTournament(false)}>
            <TournamentBox item={joinViaCodeTournament} setIsRulesPopup={fetchRulesData} setPricePointPool={() => { selectedItem(joinViaCodeTournament); setPricePointPool(true) }} getjoin={getjoin} />
          </Popup>
        )}

        {isRulesPopup && (
          <RulesPopup
            isOpen={isRulesPopup}
            title={t('tournament_list.rules')}
            onClose={() => setIsRulesPopup(false)}
            rules={rules}
          />
        )}
        {isPricePointPoolModel && (
          <WinningBreakup
            isOpen={isPricePointPoolModel}
            title={t('tournament_list.winning_breakup')}
            onClose={() => setPricePointPool(false)}
            prizePool={prizePool}
            tournament={item}
            contestData={item}
            contestId={item?._id}
            popupType={'tournament'}
          />
        )}
        {/* Round Popup */}
        {isTournamentRound && (
          <TournamentRoundPopup
            isOpen={isTournamentRound}
            title={item?.title}
            onClose={() => setisTournamentRound(false)}
            tournaments={item}
            rounds={rounds}
            firstRoundId={firstRoundId}
            setFirstRoundId={setFirstRoundId}
            setSelectedMatchDate={setSelectedMatchDate}
            setisTournamentRound={setisTournamentRound}
            setisTournamentJoiningPopup={onJoinContestClick}
            setWalletUsageData={setWalletUsageData}
            setCoinStore={setCoinStore}
          />
        )}
        {isTournamentJoiningPopup && (
          <JoiningPopup
            isOpen={isTournamentJoiningPopup}
            title={item?.title}
            popupType={'tournament'}
            onClose={() => setisTournamentJoiningPopup(false)}
            tournaments={item}
            selectedMatchDate={selectedMatchDate}
            // uniqueIgn={uniqueIgn}
            setingameName={setUniqueIgn}
            walletUsage={walletUsage}
            onJoinTournament={onJoinTournament}
            isDisableJoinBtn={isDisableJoinBtn}
            setIsDisableJoinBtn={setIsDisableJoinBtn}
          />
        )}
        {isSubscriptionPopup && (
          <NonPremiumMaxJoinPopup
          isOpen={isSubscriptionPopup}
          message={t('premium.you_have_already_joined_today', { title: "tournament", total:  localStorage?.getItem('noOfTournament') })}
          onClose={() => setSubscriptionPop(false)} title={"explore vi premium"}
          onSubscriptionBtnClick={() => { navigate('/more/subscription-pack') }}/>
        )}
      </BaseHome>
    </>
  );
};

export default TournamentList;
